import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, checking } = useAuth();
  if (checking || user === null) {
    return <div className="min-h-screen bg-navy flex items-center justify-center"><Loader2 className="animate-spin text-brass" size={32} /></div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
